import { useEffect, useState } from "react";
import { CiBookmarkCheck, CiSearch, CiViewList } from "react-icons/ci";
import { FaChevronRight, FaPlayCircle } from "react-icons/fa";
import { LuBookMarked } from "react-icons/lu";
import tumbnelImg from '../../assets/img/tumbnel.png';
import axios from "axios";
export default function Content() {
    const [data, setData] = useState<any>([])
    const [activeCategory, setActiveCategory] = useState('Semua');
    const [pagination, setPagination] = useState<any>({});
    const [currentPage, setCurrentPage] = useState<number>(1);

    const getAllData = async (page: number = 1, search: string = '') => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/media-education/get-all?page=${page}&search=${search}`)

            if (response && response.data && response.data.data) {
                setData(response.data.data.data);
                setPagination(response.data.data);
            } else {
                setData([])
            }
        } catch (error) {
            console.log('Error fetching data:', error);
        }
    }

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    }

    const getTopOneView = () => {
        if (data.length === 0) return null;

        const topOne = [...data].sort((a, b) => b.view - a.view)[0];
        return topOne;
    }

    const updateViewCount = async (id: string) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_ENDPOINT}/media-education/update-view/${id}`,
            );
        } catch (error) {
            console.log("Gagal update view count:", error);
        }
    };

    // Data sampel
    const categories = ['Semua'];

    useEffect(() => {
        getAllData(currentPage)
        getTopOneView()
    }, [currentPage])

    const topOne = getTopOneView();

    return (
        <div className="max-w-screen-2xl mx-auto pt-16 pb-60 p-5 md:p-5 lg:p-16">
            <div>
                <div className="flex flex-col-reverse md:flex-row md:justify-between gap-8">
                    <h1 className="text-2xl font-bold">Video Unggulan</h1>
                </div>
                {topOne ? (
                    <div className="bg-white rounded-xl shadow-md overflow-hidden">
                        <div className="md:flex">
                            <a
                                href={`/detail-media-edukasi/${topOne.slug_title}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    updateViewCount(topOne.id).then(() => {
                                        window.open(`/detail-media-edukasi/${topOne.slug_title}`, "_blank");
                                    });
                                }}
                                className="md:flex-shrink-0 relative"
                            >
                                <img
                                    className="h-48 w-full object-cover md:h-full md:w-80"
                                    src={`${process.env.REACT_APP_API_ENDPOINT}/media-education/getfile/${topOne.thumbnail}`}
                                    alt="Featured video thumbnail"
                                />
                                <div className="absolute inset-0 bg-black bg-opacity-10 flex indexs-center justify-center opacity-0 hover:opacity-100 transition">
                                    <FaPlayCircle className="h-52 md:h-72 w-16 text-white opacity-80" />
                                </div>
                            </a>
                            <div className="p-6">
                                <div className="flex items-start justify-between">
                                    <h3 className="text-xl font-semibold text-gray-900">
                                        {topOne.title}
                                    </h3>
                                </div>
                                <p className="mt-2 text-sm text-gray-600">
                                    Admin • {topOne.format_view} dilihat
                                </p>
                                <p className="mt-3 text-gray-700">
                                    {topOne.description}
                                </p>
                                <div className="mt-4 flex">
                                    <a
                                        href={`/detail-media-edukasi/${topOne.slug_title}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            updateViewCount(topOne.id).then(() => {
                                                window.open(`/detail-media-edukasi/${topOne.slug_title}`, "_blank");
                                            });
                                        }}
                                        target="_blank"
                                        className="flex items-center text-blue-600 hover:text-blue-800 font-medium"
                                    >
                                        Putar sekarang
                                        <FaChevronRight className="h-5 w-5" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="bg-white rounded-xl shadow-md overflow-hidden p-6 text-center">
                        <p className="text-gray-500">Konten tidak tersedia.</p>
                    </div>
                )}

            </div>
            {/* <div className="flex items-center space-x-2 overflow-x-auto pb-2 mb-6 mt-5">
                {categories.map(category => (
                    <button
                        key={category}
                        onClick={() => setActiveCategory(category)}
                        className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap ${activeCategory === category
                            ? 'bg-blue-600 text-white'
                            : 'bg-white text-gray-700 hover:bg-gray-100'
                            }`}
                    >
                        {category}
                    </button>
                ))}
            </div> */}
            <div className="flex flex-col-reverse md:flex-row md:justify-between gap-8 mt-5">
                <h1 className="text-2xl font-bold">Semua video</h1>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mt-5">
                {data.map((item: any, index: any) => (
                    <a
                        href={`/detail-media-edukasi/${item.slug_title}`}
                        onClick={(e) => {
                            e.preventDefault();
                            updateViewCount(item.id).then(() => {
                                window.open(`/detail-media-edukasi/${item.slug_title}`, "_blank");
                            });
                        }}
                        key={index}
                        className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition"
                    >

                        <div className="relative">
                            <img
                                src={`${process.env.REACT_APP_API_ENDPOINT}/media-education/getfile/${item.thumbnail}`}
                                alt={item.title}
                                className="w-full h-40 object-cover"
                            />
                            <div className="absolute inset-0 bg-black bg-opacity-10 flex indexs-center justify-center opacity-0 hover:opacity-100 transition">
                                <FaPlayCircle className="h-44 w-12 text-white" />
                            </div>
                            <div className="absolute bottom-2 right-2 bg-black bg-opacity-70 text-white text-xs px-2 py-1 rounded">
                                {item.duration}
                            </div>
                            {/* {video.progress > 0 && (
                                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gray-300">
                                    <div
                                        className="bg-blue-600 h-full"
                                        style={{ width: `${video.progress}%` }}
                                        aria-label={`${video.progress}% selesai`}
                                    />
                                </div>
                            )} */}
                        </div>
                        <div className="p-4">
                            <h3 className="font-medium text-gray-900 line-clamp-2 mb-1" title={item.title}>
                                {item.title}
                            </h3>
                            <p className="text-sm text-gray-600">Admin</p>
                            <div className="mt-2 flex items-center justify-between text-xs text-gray-500">
                                <div className="flex items-center">
                                    <span>{item.format_view} dilihat</span>
                                    <span className="mx-1"></span>
                                    <span>{item.created_at}</span>
                                </div>
                                {/* <div className="flex items-center">
                                    <CiViewList className="h-3 w-3 text-yellow-400" />
                                    <span className="ml-1">{item.rating}</span>
                                </div> */}
                            </div>
                        </div>
                    </a>
                ))}
            </div>
            <div className="mt-10 ">
                {pagination.total > 0 && (
                    <nav aria-label="Page navigation example" className="flex justify-end">
                        <ul className="inline-flex -space-x-px text-base h-10">
                            <li>
                                <button
                                    onClick={() => handlePageChange(pagination.current_page - 1)}
                                    disabled={!pagination.prev_page_url}
                                    className="flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-e-0 border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700"
                                >
                                    &laquo; Previous
                                </button>
                            </li>
                            {pagination.links &&
                                pagination.links.map((link: any, index: number) =>
                                    link.url && link.label !== '&laquo; Previous' && link.label !== 'Next &raquo;' ? (
                                        <li key={index}>
                                            <button
                                                onClick={() =>
                                                    handlePageChange(Number(new URL(link.url).searchParams.get('page')))
                                                }
                                                className={`flex items-center justify-center px-4 h-10 leading-tight ${link.active ? 'text-blue-600 bg-blue-50' : 'text-gray-500 bg-white'
                                                    } border border-gray-300 hover:bg-gray-100 hover:text-gray-700`}
                                            >
                                                {link.label}
                                            </button>
                                        </li>
                                    ) : null
                                )}
                            <li>
                                <button
                                    onClick={() => handlePageChange(pagination.current_page + 1)}
                                    disabled={!pagination.next_page_url}
                                    className="flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-e-0 border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700"
                                >
                                    Next &raquo;
                                </button>
                            </li>
                        </ul>
                    </nav>
                )}
            </div>
        </div>
    )
}